/**
 * Apply Gift Card Action
 * Triggered by: arc:action:applyGiftCard
 */

export const runApplyGiftCard = async (data = {}) => {
    try {
        const { giftCardCode, cartId } = data;
        
        if (!giftCardCode) {
            throw new Error('Gift card code is required');
        }

        // Trigger haptic feedback
        if ('vibrate' in navigator) {
            navigator.vibrate(50);
        }

        // Get current cart to extract gift card codes
        const cartResponse = await fetch('/cart.js');
        const currentCart = await cartResponse.json();
        
        // Prepare gift card codes array
        const existingCodes = currentCart.gift_card_codes || [];
        const newCodes = [...existingCodes, giftCardCode.trim()];

        // Use Shopify Cart API to update gift card codes
        const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes: {
                    ...currentCart.attributes,
                    gift_card_codes: newCodes.join(',')
                }
            }),
        });

        if (!response.ok) {
            throw new Error('Failed to apply gift card');
        }

        const updatedCart = await response.json();

        // Success haptic feedback
        if ('vibrate' in navigator) {
            navigator.vibrate([100, 50, 100]);
        }

        // Dispatch success event
        window.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: updatedCart, action: 'gift_card_applied' }
        }));

        return {
            success: true,
            cart: updatedCart,
            giftCardCode,
            message: 'Gift card applied successfully'
        };

    } catch (error) {
        console.error('Apply gift card error:', error);
        
        // Error haptic feedback
        if ('vibrate' in navigator) {
            navigator.vibrate([50, 50, 50]);
        }

        return {
            success: false,
            error: error.message
        };
    }
};

export default runApplyGiftCard;
